import { linkLoginRedirect } from "../../services/auth";
import { LINK_SIGN_IN } from "./types";

const linkLoginRedirectAction = (hash, redirectPath) => async (dispatch) => {
  const { user, path } = await linkLoginRedirect(hash, redirectPath);
  
  return dispatch({
    type: LINK_SIGN_IN,
    payload: { isSignedIn: true, user: user, redirectTo: path },
  });
};

export default linkLoginRedirectAction;
